<template>
    <div class="tech">
        <slide-show :data="$root.banners" :ratio="'0.21'"></slide-show>
        <router-view class="fadeIn"></router-view>
    </div>
</template>
<style lang="less" scoped>
	@red: #e60012;

    .banner {
        height: 550px;
        background: url(../assets/images/tech/banner.jpg) center/cover no-repeat;
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        .text {
            position: relative;
            text-align: left;
            color: #FEFEFE;
            padding-left: 456px;

            h3 {
                font-size: 71px;
                line-height: 71px;
                font-weight: 400;
                margin: 0;
            }

            h5 {
                font-size: 24px;
                font-weight: 400;
                margin: 16px 0;
            }

            h2 {
                font-size:96px;
                line-height: 96px;
                font-weight: 400;
                margin: 0;
            }

            .corner {
                position: absolute;
                border: 2px solid transparent;
                width: 42px;
                height: 42px;

                &.lt {
                    left: 0;
                    top: 0;
                    border-left-color: white;
                    border-top-color: white;
                }

                &.rt {
                    right: 0;
                    top: 0;
                    border-right-color: white;
                    border-top-color: white;
                }

                &.rb {
                    right: 0;
                    bottom: 0;
                    border-right-color: white;
                    border-bottom-color: white;
                }

                &.lb {
                    left: 0;
                    bottom: 0;
                    border-left-color: white;
                    border-bottom-color: white;
                }
            }
        }
    }

</style>
<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
           
        },
        mounted() { 
            if(this.$root.groupId){
                this.$root.getBanner(5);
            }
        },
        watch: {
            
		}
    }
</script>
